import AdvancedReport from './AdvancedReport.vue';

const AdvancedReportRoutes = {
  path: 'advancedreport',
  name: 'production.baggd',
  component: AdvancedReport,
  meta: {
    prefix_permission: 'pockets_advancedreport',
  },
};

export default AdvancedReportRoutes;
